import { fetchFactory } from 'isotope-client'

export const getMesExamens = () => fetchFactory('/candidats/me/examens')

export const postExamen = (values) => fetchFactory('/candidats/me/examens', {
	method: 'POST',
	body: JSON.stringify(values)
})

export const getResultatsExamenCcapEchoue = (idExamenCandidat) => fetchFactory(`/candidats/me/examens/${idExamenCandidat}/resultats`)
